import { async } from "q";
import { get, getFile, patch, post, remove, put } from "../../ApiService";
import { ApiUrl } from "../../ApiUrl";

export const getVehicleTypeList = async (
  ref?: string,
  page = 1,
  pageSize = 50
) => {
  try {
    const res = await get(ApiUrl.booking.vehicleTypes, {
      project: ref,
      page,
      pageSize,
    });
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const updateVehicleTypeList = async (
  ref: string,
  data: { vehicle_type: number; order: number; enabled?: boolean }[]
) => {
  try {
    const res = await post(`${ApiUrl.booking.vehicleTypes}`, data, {
      project: ref,
    });
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const reserveBookingSlot = async (ref: any, siteId: any, data: any) => {
  try {
    const res = await post(`${ApiUrl.booking.reserveSlots}`, data, {
      project: ref,
      site_id: siteId,
    });
    return res;
  } catch (error: any) {
    return error.response;
  }
};
export const createBooking = async (ref: any, siteId: any, data: any) => {
  try {
    const res = await post(`${ApiUrl.booking.createBookingcall}`, data, {
      project: ref,
      site_id: siteId,
    });
    return res;
  } catch (error: any) {
    return error.response;
  }
};
export const getSlots = async (ref: any, params: any, data: any) => {
  try {
    const res = await get(`${ApiUrl.booking.slots}?${params}`);
    return res;
  } catch (error: any) {
    return error.response;
  }
};
export const getProjectSettingList = async (ref: any) => {
  try {
    const res = await get(ApiUrl.booking.getProjectSetting, {
      project: ref,
    });
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const getBookingList = async (
  project: any,
  siteId: number,
  filterParams: string = "",
  page: number = 1,
  pageSize?: number,
  bookingType?: string,
  sort_key?: string,
  sort_direction?: string
) => {
  try {
    let params: any = {
      project,
      site_id: siteId,
      page,
      pageSize,
    };
    if (sort_key && sort_direction) {
      params.sort_key = sort_key;
      params.sort_direction = sort_direction;
    }
    const res = await get(
      `${ApiUrl.booking.bookingList}list/?bookings=${bookingType}${filterParams}`,
      params
    );
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const getBookingDetails = async (
  project: string | undefined,
  bookingId: string | undefined,
  siteId: number
) => {
  try {
    const res = await get(`${ApiUrl.booking.bookingList}${bookingId}`, {
      project,
      site_id: siteId,
    });
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const getBookingPdf = async (
  project: string | undefined,
  bookingId: string | undefined,
  siteId: number
) => {
  try {
    const res = await getFile(`${ApiUrl.booking.bookingList}${bookingId}/pdf`, {
      project,
      site_id: siteId,
    });
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const getBookingViewFields = async (project: string | undefined) => {
  try {
    const res = await get(`${ApiUrl.booking.bookingView}fields-list`, {
      project,
    });
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const getBookingViewList = async (project: string | undefined) => {
  try {
    const res = await get(`${ApiUrl.booking.bookingView}view`, {
      project,
    });
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const updateBookingView = async (
  project: string | undefined,
  id: string,
  data: any
) => {
  try {
    const res = await put(`${ApiUrl.booking.bookingView}view/${id}/`, data, {
      project,
    });
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const createBookingView = async (
  project: string | undefined,
  data: any
) => {
  try {
    const res = await post(`${ApiUrl.booking.bookingView}view/`, data, {
      project,
    });
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const deleteBookingView = async (
  project: string | undefined,
  id: string
) => {
  try {
    const res = await remove(`${ApiUrl.booking.bookingView}view/${id}/`, {
      project,
    });
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const updateBookingStatus = async (
  bookingId: string,
  project: any,
  siteId: number,
  status: object
) => {
  try {
    const res = await put(
      `${ApiUrl.booking.bookingStatusUpdate}${bookingId}/status/`,
      status,
      { project, site_id: siteId }
    );
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const undoBookingStatus = async (
  bookingId: string,
  project: any,
  siteId: number,
  body: { apply_to_all_recurring: boolean }
) => {
  try {
    const res = await put(
      `${ApiUrl.booking.bookingStatusUpdate}${bookingId}/status/undo/`,
      body,
      { project, site_id: siteId }
    );
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const deleteBooking = async (
  project: string | undefined,
  bookingId: string,
  siteId: number
) => {
  try {
    const res = await remove(`${ApiUrl.booking.bookingList}${bookingId}`, {
      project,
      site_id: siteId,
    });
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const uploadFlexFiles = async (
  project: any,
  fileData: any,
  siteId?: number
) => {
  try {
    const res = await post(`${ApiUrl.booking.uploadFlexFiles}`, fileData, {
      project,
      site_id: siteId,
    });
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const getFlexFiles = async (
  project: any,
  siteId: number,
  bookingRef: string
) => {
  try {
    const res = await get(`${ApiUrl.booking.uploadFlexFiles}`, {
      project,
      site_id: siteId,
      booking: bookingRef,
    });
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const getNotes = async (
  project: any,
  bookingId: string,
  siteId: number
) => {
  try {
    const res = await get(`${ApiUrl.booking.bookingList}${bookingId}/notes/`, {
      project,
      site_id: siteId,
    });
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const addNotes = async (
  project: any,
  bookingId: string,
  payload: object,
  siteId: number
) => {
  try {
    const res = await post(
      `${ApiUrl.booking.bookingList}${bookingId}/notes/`,
      payload,
      { project, site_id: siteId }
    );
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const getBookingActivity = async (
  project: any,
  bookingId: string,
  siteId: number
) => {
  try {
    const res = await get(`${ApiUrl.booking.activity}${bookingId}`, {
      project,
      site_id: siteId,
    });
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const bookingExport = async (
  project: any,
  siteId: number,
  page: number,
  pageSize: number,
  data: string = ""
) => {
  try {
    const res = await get(
      `${ApiUrl.booking.bookingList}export/?page=${page}&pageSize=${pageSize}${data}`,
      { project, site_id: siteId }
    );
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const addVehicle = async (
  bookingId: any,
  project: any,
  siteId: number
) => {
  try {
    const res = await patch(
      `${ApiUrl.booking.bookingList}${bookingId}/add-vehicle/`,
      {},
      { project, site_id: siteId }
    );
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const removeVehicle = async (
  bookingId: any,
  project: any,
  siteId: number
) => {
  try {
    const res = await remove(
      `${ApiUrl.booking.bookingList}${bookingId}/remove-vehicle/`,
      { project, site_id: siteId }
    );
    return res;
  } catch (error: any) {
    return error.response;
  }
};
export const moveBooking = async (
  bookingId: any,
  project: any,
  siteId: number,
  payload: any
) => {
  try {
    const res = await post(
      `${ApiUrl.booking.bookingList}${bookingId}/move/`,
      payload,
      { project, site_id: siteId }
    );
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const editBooking = async (
  bookingId: any,
  project: any,
  siteId: number,
  payload: any
) => {
  try {
    const res = await patch(
      `${ApiUrl.booking.bookingList}${bookingId}/`,
      payload,
      { project, site_id: siteId }
    );
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const rescheduleBooking = async (
  bookingId: any,
  project: any,
  siteId: number,
  payload: any
) => {
  try {
    const res = await patch(
      `${ApiUrl.booking.bookingList}${bookingId}/reschedule/`,
      payload,
      { project, site_id: siteId }
    );
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const editCheckInOutTime = async (
  bookingId: string,
  project: any,
  siteId: number,
  payload: { audit_log_id: number; datetime: string }
) => {
  try {
    const res = await put(
      `${ApiUrl.booking.bookingList}${bookingId}/edit-checkin-checkout/`,
      payload,
      { project, site_id: siteId }
    );
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const getCalendarBookingList = async (
  project: any,
  siteId: number,
  bookings: any,
  data: string = "",
  page: number = 1,
  pageSize: number = 1000
) => {
  try {
    const res = await get(
      `${ApiUrl.booking.bookingList}calendar?bookings=${bookings}&page=${page}&pageSize=${pageSize}${data}`,
      { project, site_id: siteId }
    );
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const updateProjectSettings = async (
  project: string | undefined,
  data: { value: string | boolean; setting: number }[]
) => {
  try {
    const res = await post(`${ApiUrl.booking.getProjectSetting}`, data, {
      project,
    });
    return res;
  } catch (error: any) {
    return error.response;
  }
};
